//src/services/departmentService.js
import axios from "axios";
import { BACKEND_URL } from "../utils/envConfig";

const API_URL = `/departments`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

/** Departments live in the base table (shared across organizations). */
const departmentRequest = async (config) => {
  const response = await axios({
    ...config,
    url: `${BACKEND_URL}${config.url}`,
    headers: { ...getAuthHeaders(), ...(config.headers || {}) },
  });
  return response.data;
};

export const getAllDepartment = async () => {
  return departmentRequest({ method: "GET", url: API_URL });
};

export const getDepartmentById = async (id) => {
  return departmentRequest({ method: "GET", url: `${API_URL}/${id}` });
};

export const createDepartment = async (payload) => {
  return departmentRequest({ method: "POST", url: API_URL, data: payload });
};

export const updateDepartment = async (id, payload) => {
  return departmentRequest({ method: "PUT", url: `${API_URL}/${id}`, data: payload });
};

export const deleteDepartment = async (id) => {
  return departmentRequest({ method: "DELETE", url: `${API_URL}/${id}` });
};
